import throttle from 'utils/throttle';

const SideQuickLinks = ({ el }) => {
    const visibleClass = 'is-visible';
    const minVisibleDistance = 1000; // in px
    const scrollThrottle = 200; // in ms

    if (el) {
        // throttle the check of document top position compared to the minimum visible distance from page top every 200ms
        const scrollHandler = throttle(() => {
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            if (scrollTop > minVisibleDistance) {
                el.classList.add(visibleClass);
            } else {
                el.classList.remove(visibleClass);
            }
        }, scrollThrottle);

        window.addEventListener('scroll', scrollHandler);
    }
};

export default SideQuickLinks;
